import moment from 'moment-timezone';
import type { CancellationAndNoShowsReportDto } from './CancellationAndNoShowsReportDto';
import type { CancellationAndNoShowsReport, CancellationAndNoShowsRow } from 'model/CancellationAndNoShowsReport';

export const convertToCancellationAndNoShowsReport = (
    dto: CancellationAndNoShowsReportDto,
    timeZone: string
): CancellationAndNoShowsReport => {
    const rows: CancellationAndNoShowsRow[] = (dto.rows || []).map(r => ({
        statusId: r.status_id,
        totalBookings: r.totalBookings ?? 0,
        totalValue: r.totalValue ?? 0,
        depositCollected: r.depositCollected ?? 0,
        rebooked: {
            value: r.rebooked?.value ?? 0,
            pct: r.rebooked?.pct ?? 0
        },
        notRebooked: {
            value: r.notRebooked?.value ?? 0,
            pct: r.notRebooked?.pct ?? 0
        },
        missedRevenue: r.missedRevenue ?? 0
    }));

    return {
        start: moment(dto.start).tz(timeZone),
        end: moment(dto.end).tz(timeZone),
        rebookWindowDays: dto.rebook_window_days ?? 30,
        rows
    };
};
